/* eslint-disable no-nested-ternary */
import React from 'react';
import Link from '../../../../../components/Link/Link';
import s from './CricketStats.scss';
import { statsValueMap } from './CricketStatsUtils';

const CricketStatsCard = ({ cricketStatsData, tournamentName }) => (
  <>
    {cricketStatsData &&
      Array.isArray(cricketStatsData) &&
      cricketStatsData.length > 0 &&
      cricketStatsData.map((statsitems, index) => {
        const classes = ['blue', 'green', 'orange'];
        const colorCodeClass = classes[index % classes.length];
        return (
          statsitems && (
            <div className={s.stats_cont}>
              <div className={`${s.stats_box} ${s[colorCodeClass]}`}>
                <Link
                  to={`/sports/cricket/${tournamentName}/series-stats/${
                    statsitems.stat_id
                  }/${statsitems?.display_name
                    .replace(/\s+/g, '-')
                    .toLowerCase()}`}
                >
                  <div className={`${s.top_header}`}>
                    <div /> {statsitems?.display_name}
                  </div>
                  <div className={s.score_stats}>
                    {statsitems &&
                      statsitems.leaderboard &&
                      statsitems.leaderboard.length > 0 &&
                      Array.isArray(statsitems.leaderboard) &&
                      statsitems.leaderboard.length > 0 &&
                      statsitems.leaderboard.slice(0, 2).map(leaderItems => (
                        <div className={s.name_socre}>
                          <div>
                            {statsitems.stat_id === 51
                              ? `${leaderItems.Batsman1_Name} and ${
                                  leaderItems.Batsman2_Name
                                } `
                              : statsitems.stat_id === 24 ||
                                statsitems.stat_id === '24' ||
                                statsitems.stat_id === 25 ||
                                statsitems.stat_id === '25'
                                ? leaderItems?.team_name
                                : leaderItems?.player_name}
                          </div>
                          {/* <div>{leaderItems?.highest_score}</div> */}
                          <div>
                            {statsValueMap[statsitems.stat_id]
                              ? leaderItems[statsValueMap[statsitems.stat_id]]
                              : ''}
                          </div>
                        </div>
                      ))}
                    {statsitems &&
                      statsitems.leaderboard &&
                      statsitems.leaderboard.length === 0 &&
                      Array.isArray(statsitems.leaderboard) && (
                        <>
                          <div className={s.name_socre}>
                            <div />
                            <div>--</div>
                          </div>
                          <div className={s.name_socre}>
                            <div />
                            <div>--</div>
                          </div>
                        </>
                      )}
                  </div>
                </Link>
              </div>

              <div className={s.seeall}>
                {statsitems &&
                  statsitems.leaderboard &&
                  statsitems.leaderboard.length > 0 &&
                  Array.isArray(statsitems.leaderboard) &&
                  statsitems.leaderboard.length > 0 && (
                    <Link
                      to={`/sports/cricket/${tournamentName}/series-stats/${
                        statsitems.stat_id
                      }/${statsitems?.display_name
                        .replace(/\s+/g, '-')
                        .toLowerCase()}`}
                    >
                      See All
                    </Link>
                  )}
              </div>
            </div>
          )
        );
      })}
  </>
);

export default CricketStatsCard;
